import React from 'react';
import SearchForm from './SearchForm';

const Search = () => {
	return <SearchForm />;
};

export default Search;
